export default __webpack_public_path__ + "static/media/icon-user-management.ccb2f528.svg";